import { InjectionKey, reactive } from '@vue/composition-api'
import { StoreType as FormStoreType } from './Form'

export type InputType = {
    form_id: number
    name: string
    tel: string
    email: string
    zip: string
    address: string
    construction: string
    howto: string
    selectedHowto: {
        ordered: string
        label: string
        body: string
        has_address: string
    } | null
    ipad: string
    shop: string
    selectedShop: {
        ordered: string
        label: string
        is_input: string
    } | null
    shop_other: string
    date: string
    time: string
    question: { [key: string]: string | any[] | null }
    question_other: { [key: string]: { [key: string]: string | null } }
    important: string
    request_type: number
    request1: string
    request2: string
    request3: string
    request_model1: string
    request_model2: string
    request_model3: string
    requests: string[]
    request_other: string
    privacy: boolean
    first_time: string
}

export type RequestType = {
    form_id?: number
    name: string
    tel: string
    email: string
    howto: string
    zip: string
    address: string
    construction: string
    ipad: string
    shop: string
    shop_other: string
    date: string
    time: string
    question: { [key: string]: string | string[] }
    question_other: { [key: string]: { [key: string]: string } }
    important: string
    request_type: number
    request1: string
    request2: string
    request3: string
    request_model1: string
    request_model2: string
    request_model3: string
    requests: string[]
    request_other: string
    privacy: string
    first_time: string
}

export default function store(form_id: number) {
    const state = reactive<InputType>({
        form_id,
        name: '',
        tel: '',
        email: '',
        zip: '',
        address: '',
        construction: '',
        howto: '',
        selectedHowto: null,
        ipad: '',
        shop: '',
        selectedShop: null,
        shop_other: '',
        date: '',
        time: '',
        question: {},
        question_other: {},
        important: '',
        request_type: 1,
        request1: '',
        request2: '',
        request3: '',
        request_model1: '',
        request_model2: '',
        request_model3: '',
        requests: [],
        request_other: '',
        privacy: false,
        first_time: '',
    })

    return {
        // form_id
        get form_id() {
            return state.form_id
        },

        // name
        get name() {
            return state.name
        },
        set name(name) {
            state.name = name
        },

        // tel
        get tel() {
            return state.tel
        },
        set tel(tel) {
            state.tel = tel
        },

        // email
        get email() {
            return state.email
        },
        set email(email) {
            state.email = email
        },

        // zip
        get zip() {
            return state.zip
        },
        set zip(zip) {
            state.zip = zip
        },

        // address
        get address() {
            return state.address
        },
        set address(address) {
            state.address = address
        },

        // construction
        get construction() {
            return state.construction
        },
        set construction(construction) {
            state.construction = construction
        },

        // howto
        get howto() {
            return state.howto
        },
        set howto(howto) {
            state.howto = howto
        },
        get selectedHowto() {
            return state.selectedHowto
        },
        set selectedHowto(selectedHowto) {
            state.selectedHowto = selectedHowto
        },

        // ipad
        get ipad() {
            return state.ipad
        },
        set ipad(ipad) {
            state.ipad = ipad
        },

        // shop
        get shop() {
            return state.shop
        },
        set shop(shop) {
            state.shop = shop
        },
        get selectedShop() {
            return state.selectedShop
        },
        set selectedShop(selectedShop) {
            state.selectedShop = selectedShop
        },

        // shop_other
        get shop_other() {
            return state.shop_other
        },
        set shop_other(shop_other) {
            state.shop_other = shop_other
        },

        // date
        get date() {
            return state.date
        },
        set date(date) {
            state.date = date
        },

        // time
        get time() {
            return state.time
        },
        set time(time) {
            state.time = time
        },

        // question
        get question() {
            return state.question
        },
        set question(question) {
            state.question = { ...question }
        },

        // question_other
        get question_other() {
            return state.question_other
        },
        set question_other(question_other) {
            state.question_other = { ...question_other }
        },

        // important
        get important() {
            return state.important
        },
        set important(important) {
            state.important = important
        },

        // request_type
        get request_type() {
            return state.request_type
        },
        set request_type(request_type) {
            state.request_type = request_type
        },

        // request1
        get request1() {
            return state.request1
        },
        set request1(request1) {
            state.request1 = request1
        },

        // request2
        get request2() {
            return state.request2
        },
        set request2(request2) {
            state.request2 = request2
        },

        // request3
        get request3() {
            return state.request3
        },
        set request3(request3) {
            state.request3 = request3
        },

        // request_model1
        get request_model1() {
            return state.request_model1
        },
        set request_model1(request_model1) {
            state.request_model1 = request_model1
        },

        // request_model2
        get request_model2() {
            return state.request_model2
        },
        set request_model2(request_model2) {
            state.request_model2 = request_model2
        },

        // request_model3
        get request_model3() {
            return state.request_model3
        },
        set request_model3(request_model3) {
            state.request_model3 = request_model3
        },

        // requests
        get requests() {
            return state.requests
        },
        set requests(requests) {
            state.requests = requests
        },

        // request_other
        get request_other() {
            return state.request_other
        },
        set request_other(request_other) {
            state.request_other = request_other
        },

        // privacy
        get privacy() {
            return state.privacy
        },
        set privacy(privacy) {
            state.privacy = privacy
        },

        // first_time
        get first_time() {
            return state.first_time
        },
        set first_time(first_time) {
            state.first_time = first_time
        },

        update(data: RequestType | null, formStore: FormStoreType) {
            if (!data) {
                return
            }

            // Question Convert
            if (data.question) {
                Object.keys(data.question).forEach((key) => {
                    const question = data.question[key]

                    if (typeof question !== 'string') {
                        const values: any[] = []

                        const formQuestion = formStore.questions.find(
                            (q) => q.ordered == key
                        )
                        if (!formQuestion) {
                            return
                        }

                        Object.keys(question).forEach((subKey) => {
                            const inputQuestion = question[subKey]

                            const inputAnswer = formQuestion.answer!.find(
                                (fq) => fq.label === inputQuestion
                            )

                            if (inputAnswer) {
                                values.push(inputAnswer)
                            }
                        })

                        data.question[key] = values
                    }
                })
            }

            state.name = data.name
            state.tel = data.tel
            state.email = data.email
            state.howto = data.howto
            state.zip = data.zip
            state.address = data.address
            state.construction = data.construction
            state.ipad = data.ipad
            state.shop = data.shop
            state.shop_other = data.shop_other
            state.date = data.date
            state.time = data.time
            state.question = data.question ? { ...data.question } : {}
            state.question_other = data.question_other
                ? { ...data.question_other }
                : {}
            state.important = data.important
            state.request_type = data.request_type
            state.request1 = data.request1
            state.request2 = data.request2
            state.request3 = data.request3
            state.request_model1 = data.request_model1
            state.request_model2 = data.request_model2
            state.request_model3 = data.request_model3
            state.requests = data.requests ? [...data.requests] : []
            state.request_other = data.request_other
            state.privacy = data.privacy == '1'
            state.first_time = data.first_time
        },
    }
}

export type StoreType = ReturnType<typeof store>
export const StoreKey: InjectionKey<StoreType> = Symbol('InputType')
